// 画像ファイルのバリデーション関数
export const validateImageFile = (file, maxSize = 5 * 1024 * 1024) => {
  if (!file) {
    return { valid: false, error: 'ファイルが選択されていません。' };
  }
  
  if (file.size > maxSize) {
    const maxSizeMB = Math.round(maxSize / 1024 / 1024);
    return { 
      valid: false, 
      error: `ファイルサイズは${maxSizeMB}MB以下にしてください。現在のサイズ: ${Math.round(file.size / 1024 / 1024 * 10) / 10}MB` 
    };
  }
  
  if (!file.type.startsWith('image/')) {
    return { 
      valid: false, 
      error: '画像ファイルを選択してください。対応形式: JPEG, PNG, GIF, WebP' 
    };
  }
  
  return { valid: true };
};

// Firebase Storage エラーメッセージの統一
export const UPLOAD_ERROR_MESSAGES = {
  'storage/unauthorized': 'アップロード権限がありません。ファイルサイズや形式を確認してください。',
  'storage/canceled': 'アップロードがキャンセルされました。',
  'storage/quota-exceeded': 'ストレージ容量を超過しています。管理者にお問い合わせください。',
  'storage/retry-limit-exceeded': 'アップロードに時間がかかりすぎています。ネットワーク接続を確認してください。',
  'storage/invalid-checksum': 'ファイルが破損している可能性があります。再度お試しください。',
  'default': 'アップロードに失敗しました。'
};

// Firebase Storage エラーメッセージを取得
export const getUploadErrorMessage = (error) => {
  return UPLOAD_ERROR_MESSAGES[error.code] || UPLOAD_ERROR_MESSAGES.default;
};
